import { ui } from "@/components/ui";
import { ChevronRight } from "lucide-react";
import { useState } from "react";

interface CallEditDialogProps {
	label: string;
	children: React.ReactNode;
}

const CallEditDialog = ({ label, children }: CallEditDialogProps) => {
	const [open, setOpen] = useState<boolean>(false);

	return (
		<ui.Dialog open={open} onOpenChange={setOpen}>
			<button
				onClick={() => setOpen(true)}
				type="button"
				className="group flex justify-between items-center hover:bg-primary/5 pr-2 rounded-md w-full text-primary hover:text-primary/90 text-sm text-left hover:underline underline-offset-2 transition-all duration-200"
				data-testid={`${label?.toLowerCase().replace(/\s+/g, "-")}-trigger`}
			>
				<span>{label}</span>
				<ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 duration-200" />
			</button>
			<ui.DialogContent>
				<ui.DialogHeader>
					<ui.DialogTitle className="text-slate-900 dark:text-slate-100">
						{label}
					</ui.DialogTitle>
				</ui.DialogHeader>
				<ui.ScrollArea className="md:p-2 lg:p-4 max-h-[80vh]">
					{children}
					<ui.ScrollBar />
				</ui.ScrollArea>
			</ui.DialogContent>
		</ui.Dialog>
	);
};

export default CallEditDialog;
